var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadphonesIcon = function SvgHeadphonesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.449 8.385c0 1.769.435 2.788.653 3.077L4.602 15C3.165 15-.23 13.084.012 8.385c.348-6.743 5-8.403 7.5-8.385v1.18c-5.26 0-6.063 4.993-6.063 7.205"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.67 12.31V15c-1.514 0-2.742-1.204-2.742-2.69S3.156 9.62 4.67 9.62zM13.551 8.385c0 1.769-.435 2.788-.653 3.077L10.398 15c1.437 0 4.832-1.916 4.59-6.615-.348-6.743-5-8.403-7.5-8.385v1.18c5.26 0 6.063 4.993 6.063 7.205"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.305 12.31V15c1.535 0 2.78-1.204 2.78-2.69 0-1.484-1.245-2.688-2.78-2.688z"
  })));
};
export default SvgHeadphonesIcon;